var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"rom_graph"}},[_c('v-chart',{ref:"romChart",staticStyle:{"width":"100%"},attrs:{"options":_vm.getChartData,"autoresize":""},on:{"finished":_vm.getChartImage}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }